import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPause: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPause"><Path d="M4.75 6C4.75 4.75736 5.75736 3.75 7 3.75C8.24264 3.75 9.25 4.75736 9.25 6V18C9.25 19.2426 8.24264 20.25 7 20.25C5.75736 20.25 4.75 19.2426 4.75 18V6Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M14.75 6C14.75 4.75736 15.7574 3.75 17 3.75C18.2426 3.75 19.25 4.75736 19.25 6V18C19.25 19.2426 18.2426 20.25 17 20.25C15.7574 20.25 14.75 19.2426 14.75 18V6Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPause;
